// src/config/aiStatus.ts
//
// AI 機能（AIチャット・二次試験のAI添削）を**一時停止**するための1か所のスイッチ。
//
// なぜ（2026-09-29）:
//   本番で AIチャットと二次添削が **500 で全滅**していた。原因は
//   **設定されている API キーがすべて無効**（OpenAI 2種が 401、Gemini が 400）。
//   利用者には生のエラーが出て、購入画面では「1日200回まで」と**動かない機能を宣伝**していた。
//   有効な鍵は課金アカウントの操作が要る（CEO 依頼中）ため、**戻るまで訴求を下ろす**。
//
// 鍵が戻ったら **このフラグを false にするだけ**で元に戻る（探し回らなくていいよう1か所にした）。
// 併せて導線ガードに「AI の疎通」段があるので、鍵が再び死んだら翌朝落ちる。

/** AI 機能を一時停止しているか。鍵が復旧したら false に戻す */
// 2026-09-29: 有効な Gemini の鍵が届き、本番で AIチャット・二次添削とも 200 を実測したため解除。
// 再び止めるときは true に戻すだけでよい（画面ごとに探し回らないための1か所）。
export const AI_FEATURES_SUSPENDED = false;

/** 停止中に利用者へ見せる文言（生のエラーを見せない） */
export const AI_SUSPENDED_MESSAGE =
  'AI機能は現在メンテナンス中です。復旧までしばらくお待ちください。ご不便をおかけします。';

/** 停止中に購入画面などで機能名の横に添える短い印 */
export const AI_SUSPENDED_BADGE = '（一時停止中）';
